// Bewertungs-Karussell (Judge.me): Reihenfolge, Auswahl, Einblenden, Handy-Pfeile, "Mehr lesen".
//
// Wichtig für die Ladezeit: Judge.me baut seine Karten verzögert und in mehreren Schüben.
// Früher haben hier vier Dauerschleifen im 100–400-ms-Takt nachgesehen und dabei jedes Mal
// Höhen gemessen — das erzwingt ein Neuberechnen des Layouts und kostete über acht Sekunden
// Blockierzeit. Jetzt horcht ein einziger MutationObserver, bündelt die Änderungen und
// stellt sich ab, sobald Ruhe eingekehrt ist. Jede Karte wird genau einmal angefasst.
(function () {
  'use strict';

  // ---------- gemeinsamer Takt ----------
  var hoerer = [];
  var beobachter = null;
  var zeitgeber = null;
  var stillgelegt = null;
  var START = Date.now();

  function ausfuehren() {
    for (var i = 0; i < hoerer.length; i++) {
      try { hoerer[i](); } catch (e) { /* ein kaputter Teil darf die übrigen nicht mitreißen */ }
    }
  }

  function anstossen() {
    clearTimeout(zeitgeber);
    zeitgeber = setTimeout(ausfuehren, 150);          // Schübe bündeln
    clearTimeout(stillgelegt);
    stillgelegt = setTimeout(abschalten, 3000);       // 3 s Ruhe = fertig
  }

  function abschalten() {
    if (beobachter) { beobachter.disconnect(); beobachter = null; }
    clearTimeout(zeitgeber);
    ausfuehren();                                     // ein letzter sauberer Durchlauf
  }

  function aufKarussell(fn) {
    hoerer.push(fn);
    if (beobachter) return;
    beobachter = new MutationObserver(function () {
      if (Date.now() - START > 20000) { abschalten(); return; }   // Notbremse
      anstossen();
    });
    beobachter.observe(document.documentElement, { childList: true, subtree: true });
    anstossen();
  }

  function entprellt(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms || 200); };
  }

  // ---------- Reihenfolge und Auswahl ----------
  // Auf PC zeigt das Karussell 6 Karten als Raster (CSS in schnorv-pdp.css), auf dem Handy wischt man.
  var MAX = 6;
  var MAX_MOBILE = 8;
  // Diese Bewertungen sollen zuerst stehen (Reihenfolge wie hier). Welche Karten das Karussell
  // überhaupt liefert, entscheidet Judge.me — fehlt eine, wird mit den übrigen aufgefüllt.
  // Reihenfolge bewusst gemischt: die vier ähnlichen Fotos (Kissen quer vor dem Bauch) stehen nie
  // nebeneinander, dazwischen je ein andersartiges (Kissen hochkant, anderer Raum).
  var WANTED = ['Ruth B', 'Leonie O', 'Christine M', 'Stefani L', 'Monica R', 'Maria F'];

  function nameOf(card) {
    var n = card.querySelector('.jdgm-reviewer-name');
    return n ? n.textContent.trim() : '';
  }

  function rank(card) {
    var name = nameOf(card);
    for (var i = 0; i < WANTED.length; i++) {
      if (name.indexOf(WANTED[i]) === 0) return i;
    }
    return WANTED.length + 1;
  }

  function realCards() {
    return Array.prototype.filter.call(document.querySelectorAll('.jdgm-carousel-item'), function (el) {
      return !/jdgm-clone/.test(el.className);
    });
  }

  function trimCards() {
    var real = realCards();
    if (!real.length) return [];
    var limit = window.innerWidth >= 750 ? MAX : MAX_MOBILE;
    // Wunschliste zuerst, dann der Rest in gelieferter Reihenfolge (stabil sortiert)
    var sorted = real.map(function (el, i) { return { el: el, i: i, r: rank(el) }; })
      .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
      .map(function (x) { return x.el; });
    sorted.forEach(function (el, i) {
      if (el.style.order !== String(i)) el.style.order = i;
      if (i >= limit) { if (!el.hasAttribute('data-s-hidden')) el.setAttribute('data-s-hidden', '1'); }
      else if (el.hasAttribute('data-s-hidden')) el.removeAttribute('data-s-hidden');
    });
    return sorted.slice(0, limit);
  }

  // ---------- gestaffeltes Einblenden ----------
  var einblendBeobachter = null;
  function reveal() {
    if (!document.querySelector('.jdgm-cards-carousel')) return;
    var cards = trimCards();
    if (!cards.length) return;
    var heading = document.querySelector('[class*="__text_ULxw9z"], .text-block--text_ULxw9z');
    var badge = document.querySelector('.jdgm-widget.jdgm-preview-badge:not(.product-details *)');
    var button = document.querySelector('[class*="ai-quantity-scroll-button-"]:not([class*="__inner"])');
    var note = document.querySelector('[class*="__text_schnorv_cta_note"], .text-block--text_schnorv_cta_note');
    var seq = [heading, badge].concat(cards, [button, note]).filter(Boolean);

    if (!('IntersectionObserver' in window)) {
      seq.forEach(function (el) { el.classList.add('s-rev'); el.classList.add('is-in'); });
      return;
    }
    if (!einblendBeobachter) {
      einblendBeobachter = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); einblendBeobachter.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    seq.forEach(function (el, i) {
      if (el.classList.contains('s-rev')) return;     // jede Kachel nur einmal
      el.style.setProperty('--s-i', i);
      el.classList.add('s-rev');
      einblendBeobachter.observe(el);
    });
  }

  aufKarussell(reveal);
  window.addEventListener('resize', entprellt(trimCards, 250));

  // ---------- "Mehr lesen" ----------
  // Erst alle Kappungen setzen, dann alle Höhen lesen, dann alle Knöpfe bauen.
  // Lesen und Schreiben getrennt zu halten verhindert das ständige Neuberechnen des Layouts.
  function mehrLesen() {
    var cards = document.querySelectorAll('.jdgm-cards-carousel .jdgm-carousel-item');
    if (!cards.length) return;
    var offen = [];
    Array.prototype.forEach.call(cards, function (card) {
      if (card.hasAttribute('data-s-more')) return;   // schon erledigt
      var box = card.querySelector('.jdgm-text');
      if (!box) return;
      var p = box.querySelector('p') || box;
      if (!p.textContent.trim()) return;              // Text noch nicht da — nächste Runde
      card.setAttribute('data-s-more', '1');
      p.classList.add('s-clamp');
      offen.push({ box: box, p: p, ueberlaeuft: false });
    });
    if (!offen.length) return;

    offen.forEach(function (x) { x.ueberlaeuft = x.p.scrollHeight - x.p.clientHeight >= 6; });

    offen.forEach(function (x) {
      if (!x.ueberlaeuft) { x.p.classList.remove('s-clamp'); return; }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 's-more';
      btn.textContent = 'Mehr lesen';
      // Der Tipp darf nicht zur Bewertungskarte durchrutschen: Judge.me oeffnet sonst bei jedem
      // Klick auf die Karte sein Vollbild-Popup, statt dass der Text aufklappt.
      ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (typ) {
        btn.addEventListener(typ, function (e) { e.stopPropagation(); }, { passive: true });
      });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var auf = x.p.classList.toggle('is-open');
        x.p.classList.toggle('s-clamp', !auf);
        btn.textContent = auf ? 'Weniger anzeigen' : 'Mehr lesen';
      });
      x.box.appendChild(btn);
    });
  }

  aufKarussell(mehrLesen);

  // ---------- Handy: Pfeile und Punkte ----------
  var PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';
  var NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

  function handyNav() {
    if (window.innerWidth >= 750) return;
    var track = document.querySelector('.jdgm-cards-carousel .jdgm-videos-container');
    if (!track || track.dataset.sNav) return;
    // Nur sichtbare Karten, in der Reihenfolge, in der sie auf dem Bildschirm stehen. trimCards()
    // sortiert per CSS order um - nach DOM-Reihenfolge zeigten Punkte und Pfeile auf falsche Karten.
    function karten() {
      return Array.prototype.filter.call(track.querySelectorAll('.jdgm-carousel-item'), function (el) {
        return !/jdgm-clone/.test(el.className) && el.offsetWidth > 0;
      }).sort(function (a, b) { return a.getBoundingClientRect().left - b.getBoundingClientRect().left; });
    }
    if (karten().length < 2) return;
    track.dataset.sNav = '1';
    var huelle = track.parentElement;

    // Judge.me haengt eigene Wisch-Lauscher an .jdgm-content (touchmove, nicht passiv). Die hielten das
    // Wischen an und schoben die Karten per transform - das ist auf dem Handy abgeschaltet. Darum ging
    // das Karussell mal mit, mal nicht. Beruehrungen enden jetzt hier, das Wischen macht der Browser.
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(function (typ) {
      huelle.addEventListener(typ, function (e) { e.stopPropagation(); }, { passive: true });
    });

    var nav = document.createElement('div'); nav.className = 's-car-nav';
    var prev = document.createElement('button'); prev.type = 'button'; prev.className = 's-car-btn'; prev.setAttribute('aria-label', 'Vorherige Bewertung'); prev.innerHTML = PREV;
    var next = document.createElement('button'); next.type = 'button'; next.className = 's-car-btn'; next.setAttribute('aria-label', 'Nächste Bewertung'); next.innerHTML = NEXT;
    var dots = document.createElement('div'); dots.className = 's-car-dots';
    nav.appendChild(prev); nav.appendChild(dots); nav.appendChild(next);
    huelle.insertBefore(nav, track.nextSibling);

    function punkte(n) {
      while (dots.children.length < n) { var d = document.createElement('span'); d.className = 's-car-dot'; dots.appendChild(d); }
      while (dots.children.length > n) dots.removeChild(dots.lastChild);
    }
    function current(liste) {
      var tr = track.getBoundingClientRect(), mid = tr.left + tr.width / 2, best = 0, bd = 1e9;
      liste.forEach(function (c, i) {
        var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    // Schnell hintereinander getippt: vom angesteuerten Ziel aus weiterzaehlen, nicht von der
    // Karte, die gerade noch halb in der Mitte steht - sonst blieb der zweite Tipp wirkungslos.
    var ziel = null, zielZeit = 0, aufraeumen = null;
    function freigeben() {
      clearTimeout(aufraeumen);
      track.style.removeProperty('scroll-snap-type');
      track.style.removeProperty('scroll-behavior');
    }
    function mitteAuf(karte) {
      var r = karte.getBoundingClientRect(), tr = track.getBoundingClientRect();
      track.scrollBy({ left: (r.left + r.width / 2) - (tr.left + tr.width / 2), behavior: 'smooth' });
      var fertig = function () { track.removeEventListener('scrollend', fertig); freigeben(); };
      track.addEventListener('scrollend', fertig);
      clearTimeout(aufraeumen);
      aufraeumen = setTimeout(fertig, 700);
    }
    function goTo(schritt, ab) {
      var liste = karten(); if (!liste.length) return;
      var von = ab !== undefined ? ab : (ziel !== null && Date.now() - zielZeit < 600) ? ziel : current(liste);
      var i = Math.max(0, Math.min(liste.length - 1, von + schritt));
      ziel = i; zielZeit = Date.now();
      mitteAuf(liste[i]);
    }

    // Wischen: genau eine Karte pro Wisch. Der Browser allein schoss bei kraeftigem Schnippen
    // ueber Karten hinweg (trotz scroll-snap-stop). Die Karte folgt dem Finger, beim Loslassen
    // geht es eine weiter oder zurueck. Senkrecht scrollt die Seite (touch-action: pan-y).
    var sx = 0, sy = 0, sLinks = 0, sIndex = 0, modus = null, lx = 0;
    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { modus = 'aus'; return; }
      var t = e.touches[0];
      sx = lx = t.clientX; sy = t.clientY; sLinks = track.scrollLeft;
      sIndex = current(karten()); modus = null;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (modus === 'aus' || modus === 'senkrecht') return;
      var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (modus === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        modus = Math.abs(dx) > Math.abs(dy) ? 'waagrecht' : 'senkrecht';
        if (modus !== 'waagrecht') return;
        clearTimeout(aufraeumen);
        track.style.setProperty('scroll-snap-type', 'none');
        track.style.setProperty('scroll-behavior', 'auto');
      }
      lx = t.clientX;
      var w = (karten()[0] || track).offsetWidth;
      track.scrollLeft = sLinks - Math.max(-w, Math.min(w, dx));
    }, { passive: true });
    function loslassen() {
      if (modus !== 'waagrecht') { modus = null; return; }
      modus = null;
      var dx = lx - sx, richtung = 0;
      if (Math.abs(dx) >= 30) richtung = dx < 0 ? 1 : -1;
      goTo(richtung, sIndex);
    }
    track.addEventListener('touchend', loslassen, { passive: true });
    track.addEventListener('touchcancel', loslassen, { passive: true });
    var warte = false;
    function update() {
      if (warte) return;
      warte = true;
      requestAnimationFrame(function () {             // Messen nur im Zeichentakt
        warte = false;
        var liste = karten();
        punkte(liste.length);
        var i = current(liste);
        prev.disabled = i <= 0; next.disabled = i >= liste.length - 1;
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
      });
    }
    prev.addEventListener('click', function () { goTo(-1); });
    next.addEventListener('click', function () { goTo(1); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  aufKarussell(handyNav);
})();

// Block 4: Vorher/Nachher-Quadrat exakt so hoch wie die Kachel-Spalte daneben (Ober- und Unterkante bündig).
// Per CSS allein zirkulär (Breite ↔ Höhe), darum gemessen — aber höchstens drei Runden,
// jede weitere erzwingt nur neues Layout ohne sichtbaren Gewinn.
(function () {
  function fit() {
    var box = document.querySelector('.group-block-content:has(> [class*="ai-before-after-slider-"])');
    if (!box) return;
    var slider = box.querySelector('[class*="ai-before-after-container-"]');
    var grid = box.querySelector('[class*="ai-icon-grid-container-"]');
    if (!slider || !grid) return;
    // Erst ab 1100 px stehen Bild und Kacheln nebeneinander (schnorv-pdp.css). Darunter nicht
    // messen: Zwischen 750 und 1100 px schaukelte sich die Anpassung auf und zog die Seite
    // bis 3.200 px in die Breite (Handy quer, iPad hochkant).
    if (window.innerWidth < 1100) { slider.style.width = ''; slider.style.height = ''; return; }
    // Obergrenze: das Bild nimmt hoechstens die halbe Zeile ein. Ohne sie wurde es bei 1280 px
    // 932 px gross, die Kacheln daneben quetschten sich auf 226 px Breite und 1.678 px Hoehe.
    var zeile = box.getBoundingClientRect().width;
    var abstand = parseFloat(getComputedStyle(box).columnGap) || 32;
    var hoechstens = Math.floor((zeile - abstand) / 2);
    slider.style.setProperty('width', hoechstens + 'px', 'important');
    slider.style.setProperty('height', hoechstens + 'px', 'important');
    var last = 0;
    for (var i = 0; i < 3; i++) {
      var h = Math.min(Math.round(grid.getBoundingClientRect().height), hoechstens);
      if (h < 200) return;
      if (Math.abs(h - last) < 2) break;
      slider.style.setProperty('width', h + 'px', 'important');
      slider.style.setProperty('height', h + 'px', 'important');
      last = h;
    }
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(fit, 80); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', schedule);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  document.addEventListener('shopify:section:load', schedule);
})();
